import { render, staticRenderFns } from "./AddressCell.vue?vue&type=template&id=5317224a&scoped=true&"
import script from "./AddressCell.vue?vue&type=script&lang=js&"
export * from "./AddressCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317224a",
  null
  
)

export default component.exports